import PastVisits from './PastVisits'
export default PastVisits
